/* istanbul ignore file */
import { Button, Icon, Dropdown, DropdownItem } from '@distribusion/owl-frontend-ui'
import React, { ReactElement, useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { LoginModal } from '@components/LoginModal'
import useIsMobile from '@hooks/useIsMobile'
import useLogout from '@hooks/useLogout'
import { useUserAuth } from '@hooks/userAuthProvider/provider'
import { useTranslation } from '@lib/i18n'

const SignInButton = (): ReactElement => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const { logout } = useLogout()
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const navigate = useNavigate()
  const { search } = useLocation()
  const { user, isAuthenticated, restoreSession } = useUserAuth()

  useEffect(() => {
    restoreSession()
  }, [restoreSession])

  useEffect(() => {
    if (isAuthenticated && isModalOpen) {
      setIsModalOpen(false)
    }
  }, [isAuthenticated, isModalOpen])

  const handleOpen = () => setIsModalOpen(true)
  const handleClose = () => setIsModalOpen(false)
  const navigateTo = (path: string) => navigate(`${path}${search}`)
  const handleLogout = async () => await logout()

  const userMenuItems: DropdownItem<string>[] = [
    { label: t('header.tickets'), value: 'tickets' },
    { label: t('header.subscriptions'), value: 'subscriptions' },
    // { label: t('header.payment'), value: 'payment' },
    { label: t('header.profile'), value: 'profile' },
    { label: t('header.settings'), value: 'settings' },
    { label: t('header.logOut'), value: 'logOut' },
  ]

  const handleUserMenuAction = (value: string) => {
    switch (value) {
      case 'tickets':
        navigateTo('/account/tickets')
        break
      case 'subscriptions':
        navigateTo('/account/subscriptions')
        break
      case 'payment':
        navigateTo('/account/payment')
        break
      case 'profile':
        navigateTo('/account/profile')
        break
      case 'settings':
        navigateTo('/account/settings')
        break
      case 'logOut':
        handleLogout()
        break
      default:
        break
    }
  }

  if (!isAuthenticated) {
    return (
      <div className="user-action">
        <LoginModal isOpen={isModalOpen} onClose={handleClose} />
        <Button variant="text" color={isMobile ? undefined : 'backgroundText'} onClick={handleOpen}>
          {t('header.signIn')}
        </Button>
      </div>
    )
  }

  const userName = user ? `${user.first_name} ${user.last_name}` : ''

  return (
    <div className="user-action account-dropdown">
      <Dropdown
        items={userMenuItems}
        value={null}
        onChange={handleUserMenuAction}
        label={userName}
        className="user-dropdown"
        icon={<Icon name="passenger" size="medium" />}
      />
    </div>
  )
}

export default SignInButton
